import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {GroupAPI} from '../../services/groupAPI';

@inject(AuthService, Router, GroupAPI, UserMessageService)
export class contactListt123 {
    constructor(authService, router, api, userMessageService) {

        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;

        this.saving = false;
        this.groups = [
            {id:1, label: 'aaaa'},
            {id:2, label: 'aaaa1'},
            {id:2, label: 'aaaa2'}
        ];
        this.selectedGroup = null;
        this.selectedGroupLabel = null;
        this.groupEditMode = false;

        this.contacts_top_menue = true;
        this.upload_section = false;
        this.add_group_section = false;

        this.selectedFiles = null;
        this.label = null;
        this.onlySelectedGroup = false;

        this.add_action = true;
        this.edit_action = false;
        this.del_action = false;
        this.only_group_action = false;


        this.dataList = null;
        this.count = null;
        this.limit = 10;
        this.page = 1;
        this.sortBy = "CREATE_DATE";
        this.sortDir = "DESC";
        this.selectedlimitPages = 10;

    }

    activate(params) {
        console.log(params)
        this.loading = true;
        //  this.load();
    }

    load() {
      //  console.log(">>>>>>>>>> +++++ ");
      //   this.api.getListWithPagination(
      //       this.page,
      //       this.limit,
      //       this.sortBy,
      //       this.sortDir,
      //       this.authService.getUser().token,
      //       this.saveLoadSuccess.bind(this),
      //       this.saveLoadError.bind(this)
      //   );
    }



    saveLoadSuccess(data) {
        console.log("List Data");
        console.log(data);
        this.loading = false;
        this.groups = data;

        if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;

    }

    /*itemChanged(item) {
        item.changed = true;
    }*/
listContacts(item){
    console.log(item.id);
    localStorage.setItem('list_id', item.id);
    this.router.navigate("#/user/contacts?rnd="+item.id, { replace: true, force: true });
    location.reload();

}
quickSend(item){

}
    deleteGroup(item) {
        /*if(item.new) {
            this.contacts.splice(index, 1);
        } else {*/
            if(confirm("Are you sure you wnat to delete this group ???")) {
                this.saving = true;
                this.api.delete(
                    item,
                    this.authService.getUser().token,
                    this.saveLoadSuccess.bind(this),
                    this.saveLoadError.bind(this));
            }
        //}
    }
manageContacts(){
    this.router.navigate("#/user/contacts");
}

    addContact() {
        this.groups.push({
          "label": "",
          "new": true
        });
    }
    save() {
        //if (this.validate())
        if (1)
        {
            this.saving = true;
            this.api.save(
                this.groups,
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this))
        }
    }
    addGroup(){
        //this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
        //this.router.navigate("#/user/smtp");
        //this.contacts_top_menue = false;
        //this.upload_section = false;
        this.add_group_section = true;
        //this.selectedGroupLabel = "";

        //this.add_action = true;
        //this.edit_action = false;
        //this.del_action = false;

    }
    /*editGroup(){
        this.add_group_section = true;
        this.groupEditMode = true;
        this.selectedGroupLabel = this.selectedGroup.label;
    }*/
    /*importContacts(){
        //this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
        this.contacts_top_menue = false;
        this.upload_section = true;
        //this.add_group_section = false;
    }*/
    /*uploadCsv(){

    }*/
    /*cancelCsv(){
        this.contacts_top_menue = true;
        this.upload_section = false;
        //this.add_group_section = false;
    }*/
    saveGroup(){
        var data = {
            'label': this.selectedGroupLabel,
            'id': (this.groupEditMode) ? this.selectedGroup.id : null
        };
        this.api.saveGroup(
            data,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this)
        );
    }
    /*deleteGroup(){
        if(!this.selectedGroup.id){
            alert('Please select a group to edit');
            return;
        }
        var res = confirm('Are you sure you want to delet this group?');
        if(res != true){
            console.log('Delete cancelled');
            return;
        }
        var data = {
            'id': this.selectedGroup.id
        };
        this.api.deleteGroup(
            data,
            this.authService.getUser().token,
            this.saveLoadSuccessG.bind(this),
            this.saveLoadErrorG.bind(this)
        );
    }*/
    cancelGroup(){
        //this.contacts_top_menue = true;
        //this.upload_section = false;
        this.add_group_section = false;
        /*this.groupEditMode = false;
        if(!this.selectedGroup.id){
            this.add_action = true;
            this.edit_action = false;
            this.del_action = false;;
        } else{
            this.add_action = true;
            this.edit_action = true;
            this.del_action = true;

        }*/
    }
    /*onlyGroupContacts(){
        this.onlySelectedGroup = !this.onlySelectedGroup;
        this.groupChanged();
    }*/
    /*groupChanged(){
        if(!this.selectedGroup.id){
            console.log('No Group Selected ');
            this.add_action = true;
            this.edit_action = false;
            this.del_action = false;
            this.only_group_action = false;
            this.add_group_section = false;
        } else {
            console.log('Group Selected ' + this.selectedGroup.id);
            this.add_action = true;
            this.edit_action = true;
            this.del_action = true;
            this.only_group_action = true;
            this.add_group_section = false;


        }
         var data = {
            'group_id': this.selectedGroup.id,
            'group_only': this.onlySelectedGroup
        };
        this.api.getList(
            this.authService.getUser().token,
            data,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }*/
    /*saveLoadSuccessG(data) {
        //this.loading = false;
        console.log('Group Data');
        console.log(data);
        this.groups = data;

        /*if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;*/
    //}*/

    /*saveLoadErrorG(msg) {
        this.userMessageService.setUserError("user", msg);
        //this.loading = false;

    }*/
    /*validate()
    {
        var pass = true;

        var data = this.contacts;

        for(var i = 0; i < data.length; i++) {
            //console.log(data[i].first_name  + " <-----");
            if(data[i].first_name === null || data[i].first_name.trim() == '' ) {
                this.userMessageService.setUserError('user', 'First Name is empty');
                pass = false;
            }

            if (data[i].last_name === null || data[i].last_name.trim() === '') {
                this.userMessageService.setUserError('user', 'Last name is empty');
                pass = false;
            }

            if (data[i].email === null || data[i].email.trim() === '') {
                this.userMessageService.setUserError('user', 'Email is empty');
                pass = false;
            }

            if (!this.is_email(data[i].email)) {
                this.userMessageService.setUserError('user', 'Email is not a valid email address');
                pass = false;
            }
        }

        return pass;
    }

    is_email(email) {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return emailReg.test(email);
    }*/



}
